import CartIcon from '@app/modules/Partner/CartIcon'

const CartComponent = ({ countCart }) => <CartIcon countCart={countCart} />

export default CartComponent
